import React, { useState, useEffect } from 'react';
import EncManualRappTable from './EncManualRappTable';
import EncManualRappFooter from './EncManualRappFooter';
import { getEncaissementsCompta, clearEncaissements } from '../../flux/actions/encaissementActions';
import { getAllSocietes, clearSocietes } from '../../flux/actions/societeActions';
import { getAllSocieteGroups, clearSocieteGroups } from '../../flux/actions/societegroupActions';
import { Container, Row, Col, Label, CustomInput } from 'reactstrap';

import { connect } from 'react-redux';
import { IEncManualRappContainer, IEncaissement, IEncManualRappReduxProps } from '../../types/interfaces';
import Select from 'react-select';
import { useBeforeunload } from 'react-beforeunload';
import Durations from '../Durations';
import Loading from '../Loading';
import DatePicker from "reactstrap-date-picker";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarWeek, faExclamationCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { GET_RAP_ENCAISSEMENTS } from '../../flux/types';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';

const EncManualRappContainer = ({ 
  getEncaissementsCompta,
  clearEncaissements,
  encaissement,
  getAllSocieteGroups,
  clearSocieteGroups,
  societegroup,
  auth
 }: IEncManualRappContainer) => {

  const { preEiEncaissements, loading } = encaissement;
  const { societe_groups, loading: loadingS } = societegroup;
  const [tableData, setTableData] = useState(preEiEncaissements);
  // const [encaisses, setEncaisses] = useState<IEncaissement[]>(tableData.filter(e => !!e.ei_e));
  // const [impayes, setImpayes] = useState<IEncaissement[]>(tableData.filter(e => !!e.ei_i));
  // const encaisses: IEncaissement[] = tableData.filter(e => !!e.ei_e);
  // const impayes: IEncaissement[] = tableData.filter(e => !!e.ei_i);
  const eiList: IEncaissement[] = tableData.filter(e => !!e.ei_e || !!e.ei_i);
  const selectSocieteOptions = [{id: "ALL", name: "Tous les projets"}, ...societe_groups].map(e => ({value: e, label: e.name})) || [];
  const [societeGroupValue, setSocieteGroupValue] = useState<any>('');
  const [selectedDuration, setSelectedDuration] = useState('');
  const [clearFilters, setClearFilters] = useState(false);
  const [showAllValue, setShowAllValue] = useState(false);
  
  const changeShowAllHandle = (e) => {
    setShowAllValue(e.target.checked);
  };

  useBeforeunload((e) => {
    if(eiList.length)
      e.preventDefault();
  });

  useEffect(() => {
    refresh();
  }, [getEncaissementsCompta, selectedDuration, societeGroupValue, showAllValue]);

  const refresh = () => {
    if(societeGroupValue)
      getEncaissementsCompta(selectedDuration, societeGroupValue.id === "ALL" ? "ALL" : societeGroupValue.societes.map(e => e.id), societeGroupValue.id === "ALL" ? "ALL" : societeGroupValue.societes.map(e => e.LIBELE), showAllValue ? 1 : 0, GET_RAP_ENCAISSEMENTS);
      // getEncaissementsCompta(selectedDuration, societeGroupValue.societes.map(e => e.id), societeGroupValue.societes.map(e => e.LIBELE), showAllValue ? 1 : 0, GET_RAP_ENCAISSEMENTS);
    else
      clearEncaissements();
  }

  useEffect(() => {
    getAllSocieteGroups();
  }, [getAllSocieteGroups]);

  const handleSocieteChange = data => {
    setSocieteGroupValue(data ? data.value : '');
  }

  useEffect(() => {
    return () => {
      clearEncaissements();
      clearSocieteGroups();
    }
  }, []);

  useEffect(() => {
    setTableData(preEiEncaissements.map(e => ({ei_e: false, ei_i: false, ...e})));
  }, [preEiEncaissements]);

  return (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col sm="12" md="6"><h2 className="title">Rapprochement Manuel</h2></Col>
          <Col sm="12" md="2" className="listPageFilterTitle">
            <Label for="societegroups">Projet : </Label>
          </Col>
          <Col sm="12" md="4" className="listPageFilterSelect">
              <Select
                id="societegroups"
                className="reactselect"
                classNamePrefix="react-select"
                value={societeGroupValue ? {label: societeGroupValue.societes?.map(e => e.LIBELE).join(", ") || societeGroupValue.name, value: societeGroupValue} : null}
                onChange={handleSocieteChange}
                placeholder={'Chercher par nom...'}
                isClearable={false}
                // isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='name'
                options={selectSocieteOptions}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
          </Col>
        </Row>
      </Container>
      {/* <Container><h2 className="title"><FontAwesomeIcon icon={faExclamationCircle} />&nbsp;&nbsp;Portefeuille Bureau de vente</h2></Container> */}
      <Container>
        <Row className="justify-content-center justify-content-md-end" style={{alignItems: "center"}}>
          <CustomInput type="switch" id="showAll" name="showAllSwitch" label="Inclure les anciens encaissements" checked={showAllValue} onChange={changeShowAllHandle} />
          &nbsp;<FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="showAll_tooltip" />
          <ReactTooltip effect="solid" id="showAll_tooltip" type={"dark"}>
            Cochez pour inclure les encaissements saisis avant le 01/07/2021
          </ReactTooltip>
        </Row>
      </Container>
      <Durations selectedDuration={selectedDuration} setSelectedDuration={setSelectedDuration} style={{marginTop: "6px"}} />
      {loading ? <Loading topSpace /> : <EncManualRappTable encaissementsData={tableData} setTableData={setTableData} clearFilters={clearFilters} setClearFilters={setClearFilters} />}
      {true ? <EncManualRappFooter eiList={eiList} projectGroup={societeGroupValue} refresh={refresh} setClearFilters={setClearFilters} /> : null}
    </>
  );
};

const mapStateToProps = (state: IEncManualRappReduxProps) => ({
  encaissement: state.encaissement,
  societegroup: state.societegroup,
  auth: state.auth
});

export default connect(mapStateToProps, { getEncaissementsCompta, clearEncaissements, getAllSocieteGroups, clearSocieteGroups })(EncManualRappContainer);
